import { render, staticRenderFns } from "./DashboardEditBar.vue?vue&type=template&id=feaa0d3c&"
import script from "./DashboardEditBar.vue?vue&type=script&lang=ts&"
export * from "./DashboardEditBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports